import React from 'react';
import img1 from '../../assets/logos/img1.png';
import img2 from '../../assets/logos/img2.png';
import img3 from '../../assets/logos/img3.png';
import img4 from '../../assets/logos/img4.png';
import img5 from '../../assets/logos/img5.png';
import img6 from '../../assets/logos/img6.png';

import './ClientsCarousel.css';

const logos = [
  { src: img1, alt: 'Empresa 1', link: "https://poplavskylawoffices.com" },
  { src: img2, alt: 'Empresa 2', link: "https://www.poplavskydubai.com" },
  { src: img3, alt: 'Empresa 3', link: "https://thorneglobalrealestate.com" },
  { src: img4, alt: 'Empresa 4', link: "" },
  { src: img5, alt: 'Empresa 5', link: "https://poplavskylawoffices.com/sociedades-extranjero" },
  { src: img6, alt: 'Empresa 6', link: "" },
];

const Carousel = () => {
  return (
    <div className="carousel-container">
      <div className="carousel">
        {logos.map((logo, index) => (
          <div key={index} className="carousel-item">
            {logo.link ? (
              <a href={logo.link} target="_blank" rel="noopener noreferrer">
                <img src={logo.src} alt={logo.alt} />
              </a>
            ) : (
              <img src={logo.src} alt={logo.alt} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;